import React, { Component } from 'react';
import CheckboxParameter from './CheckboxParameter.js';
import TracksDropdown from 'components/dropdowns/TracksDropdown.js';
import ParametersDropdown from 'components/dropdowns/ParametersDropdown.js';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import { connect } from "react-redux";

class ScriptComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    getTrackVariables() {
        let tracks = this.props.sequencerEngine.tracks;
        return this.props.effect.trackVariables.map(
            variable =>
                <div>
                  <div>
                    Track
                  </div>
                  <TracksDropdown
                    track={tracks[variable.get()]}
                    onSelectTrack={(track) => variable.set(track && track.trackNumber)}
                    sequencerEngine={this.props.sequencerEngine}
                  />
                </div>);
    }

    getCheckboxVariables() {
        return this.props.effect.checkboxVariables.map(
            x => <CheckboxParameter name={x.name} parameter={x}/>);
    }

    getParamVariables() {
        return this.props.effect.parameterVariables.map(
            variable =>
                <div className="parameter-dropdown">
                  <div className="parameter-dropdown-name">
                    {variable.name}
                  </div>
                <ParametersDropdown
                  parameter={variable.get()}
                  parameters={["transpose", "velocity", "chop", "duration"]}
                  onSelectParameter={(param) => variable.set(param)}
                  placeholder={variable.name}
                  sequencerEngine={this.props.sequencerEngine}
                />
                </div>
        );
    }

    render() {
        return (
            <div>
              {this.getTrackVariables()}
              {this.getParamVariables()}
              {this.getCheckboxVariables()}
            {this.props.effect.variables.map(
                variable =>
                    <EffectParameterSlider
                      name={variable.name}
                      min={variable.min}
                      max={variable.max}
                      step={Math.abs(variable.min - variable.max) <= 1 ? 0.01 : 1}
                      parameter={variable}
                      lfoEnabled={true}
                      sequencerEngine={this.props.sequencerEngine}
                      isParameter={true}
                      effectNumber={this.props.effectNumber}
                    />)}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(ScriptComponent);
